import { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import Pagination from '../../../components/Pagination';
import { getStrategies, startStrategy, stopStrategy, deleteStrategy, getOrphanStrategies, deleteOrphanStrategies } from '../../../services/StrategiesService';
import MyStrategyRow from './MyStrategyRow';
import StrategyModal from '../StrategyModal/StrategyModal';

/**
 * props:
 * - symbol
 * - onNotification
 */
function MyStrategies(props) {

    const defaultLocation = useLocation();

    function getPage(location) {
        if (!location) location = defaultLocation;
        return new URLSearchParams(location.search).get('page');
    }

    useEffect(() => {
        setPage(getPage(defaultLocation));
    }, [defaultLocation])

    const [strategies, setStrategies] = useState([]);

    const [count, setCount] = useState(0);

    const [editStrategy, setEditStrategy] = useState({});

    const [page, setPage] = useState(getPage());

    const [orphanCount, setOrphanCount] = useState(0);

    useEffect(() => {
        getStrategies(props.symbol, page || 1)
            .then(result => {
                setStrategies(result.rows);
                setCount(result.count);
            })
            .catch(err => {
                console.error(err.response ? err.response.data : err.message);
                props.onNotification({ type: 'error', text: err.response ? err.response.data : err.message });
            });

        // Verificar estratégias órfãs
        getOrphanStrategies()
            .then(result => {
                setOrphanCount(result.count || 0);
            })
            .catch(err => {
                // Ignora erros ao verificar órfãs
                console.error('Erro ao verificar estratégias órfãs:', err);
            });

    }, [page, props.symbol])

    function onEditClick(event) {
        const id = event.target.id.replace('edit', '');
        const strategy = strategies.find(s => s.id == id);
        setEditStrategy({ ...strategy });
    }

    function onStopClick(event) {
        const id = event.target.id.replace('stop', '');
        stopStrategy(id)
            .then(strategy => { window.location.reload() })
            .catch(err => {
                console.error(err.response ? err.response.data : err.message);
                props.onNotification({ type: 'error', text: err.response ? err.response.data : err.message });
            });
    }

    function onStartClick(event) {
        const id = event.target.id.replace('start', '');
        startStrategy(id)
            .then(strategy => { window.location.reload() })
            .catch(err => {
                console.error(err.response ? err.response.data : err.message)
                props.onNotification({ type: 'error', text: err.response ? err.response.data : err.message });
            });
    }

    function onDeleteClick(event) {
        const id = event.target.id.replace('delete', '');
        const strategy = strategies.find(s => s.id == id);
        const strategyName = strategy ? `${strategy.name} (${strategy.symbol})` : 'esta estratégia';
        
        if (!window.confirm(`Tem certeza que deseja deletar ${strategyName}?\n\nEsta ação irá deletar:\n- A estratégia\n- As automações de compra e venda\n- Os templates de ordem\n- O monitor\n\nEsta ação não pode ser desfeita!`)) {
            return;
        }

        deleteStrategy(id)
            .then(strategy => { 
                props.onNotification({ 
                    type: 'success', 
                    text: `Estratégia "${strategyName}" deletada com sucesso!` 
                });
                window.location.reload();
            })
            .catch(err => {
                console.error(err.response ? err.response.data : err.message);
                props.onNotification({ type: 'error', text: err.response ? err.response.data : err.message });
            });
    }

    function onStrategySubmit(strategy) {
        window.location.reload();
    }

    function onCleanOrphansClick() {
        if (!window.confirm(`Tem certeza que deseja deletar ${orphanCount} estratégia(s) órfã(s)? Esta ação não pode ser desfeita.`)) {
            return;
        }

        deleteOrphanStrategies()
            .then(result => {
                props.onNotification({ 
                    type: 'success', 
                    text: `${result.deletedCount || 0} estratégia(s) órfã(s) deletada(s) com sucesso!` 
                });
                window.location.reload();
            })
            .catch(err => {
                console.error(err.response ? err.response.data : err.message);
                props.onNotification({ 
                    type: 'error', 
                    text: err.response ? err.response.data : err.message 
                });
            });
    }

    return (
        <>
            {
                orphanCount > 0 && (
                    <div className="alert alert-warning d-flex justify-content-between align-items-center mb-3" role="alert">
                        <div>
                            <strong>Atenção!</strong> Você tem {orphanCount} estratégia(s) órfã(s) que não aparecem na listagem. 
                            Estas estratégias podem estar impedindo a criação de novas estratégias.
                        </div>
                        <button 
                            className="btn btn-warning btn-sm" 
                            onClick={onCleanOrphansClick}
                        >
                            Limpar Estratégias Órfãs
                        </button>
                    </div>
                )
            }
            <div className="card card-body border-0 shadow table-wrapper table-responsive">
                <table className="table table-hover">
                    <thead>
                        <tr>
                            <th className="border-gray-200">Símbolo</th>
                            <th className="border-gray-200">Nome</th>
                            <th className="border-gray-200">Status</th>
                            <th className="border-gray-200">Ações</th>
                        </tr>
                    </thead>
                    <tbody>
                        {
                            strategies && strategies.length
                                ? strategies.map(strategy => (<MyStrategyRow key={strategy.id} data={strategy} onEditClick={onEditClick} onStartClick={onStartClick} onStopClick={onStopClick} onDeleteClick={onDeleteClick} />))
                                : <></>
                        }
                    </tbody>
                </table>
                <Pagination count={count} />
            </div>
            <StrategyModal data={editStrategy} onSubmit={onStrategySubmit} />
        </>
    )
}

export default MyStrategies;